//Build-in libraries

import { useState } from 'react';
import NewTitleForm from '@/components/NewTitleForm/index.tsx';
//Assets and Miscellaneous
import { HasPermission } from '@/components/Permission/HasPermission';
import AccentTitle from '@/components/UI/AccentTitle';
import Button from '@/components/UI/Button';
//Custom Components
import Modal from '@/components/UI/Modal';
import OrgTitlesTable from './components/OrgTitlesTable';

export const OrganizationalTitles = () => {
  const [showNewTitleForm, setShowNewTitleForm] = useState(false);

  console.log('checking showNewTitleForm', showNewTitleForm);
  return (
    <div className='w-full'>
      {showNewTitleForm && (
        <Modal>
          <NewTitleForm closeForm={() => setShowNewTitleForm(false)} />
        </Modal>
      )}
      <div className='flex justify-between w-full items-center pr-5'>
        <AccentTitle title='Organizational Titles' />
        <HasPermission of='CREATE_TITLE'>
          <Button label='Add New Title' btnStyle='btn-primary' onClick={() => setShowNewTitleForm(true)} />
        </HasPermission>
      </div>
      <OrgTitlesTable />
    </div>
  );
};
